import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import {Session} from '../domain/session';

@Injectable()
export class LoggedInGuard  {
  constructor(protected router: Router, private session: Session) {
  }

  canActivate() {
    if (this.session.isValid()) {
      console.log('Session is valid');
      return true;
    }

    console.log('Navigating to main');

    this.router.navigate(['/']);

    return false;
  }
}
